"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
var interfaces_1 = require("../../data/interfaces");
var moment_1 = __importDefault(require("moment"));
var moment_timezone_1 = __importDefault(require("moment-timezone"));
var getRulesByUserProfileType = function (rules, userProfileType) {
    var newRules;
    switch (userProfileType) {
        case interfaces_1.UserProfileType.Student:
            newRules = rules.student;
            break;
        case interfaces_1.UserProfileType.Staff:
            newRules = rules.staff;
            break;
        default:
            newRules = {};
            console.log("No rules were found for userProfileType: " + userProfileType);
            break;
    }
    return newRules;
};
exports.getRulesByUserProfileType = getRulesByUserProfileType;
var DELIMITER = "<<@>>";
exports.DELIMITER = DELIMITER;
var getPartsByDelimiter = function (value) {
    return value.split(DELIMITER);
};
exports.getPartsByDelimiter = getPartsByDelimiter;
var EASTERN_TIME_ZONE = "America/New_York";
var convertToLocalDate = function (date) {
    return moment_timezone_1.default(date).tz(EASTERN_TIME_ZONE).format("MMM D, YYYY h:mm A zz");
};
exports.convertToLocalDate = convertToLocalDate;
var convertToLocalDateFormat = function (date) { return moment_1.default(date).format("MM/DD/YYYY"); };
exports.convertToLocalDateFormat = convertToLocalDateFormat;
var formatToStringDate = function (date) { return moment_1.default(new Date(date)).format("MM/DD/YYYY HH:mm:ss"); };
exports.formatToStringDate = formatToStringDate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoiaGVscGVyLmpzIiwic291cmNlUm9vdCI6Ii4vIiwic291cmNlcyI6WyJwZGYvbGliL2Z1bmN0aW9ucy9oZWxwZXIudHMiXSwibmFtZXMiOltdLCJtYXBwaW5ncyI6Ijs7Ozs7QUFBQSxvREFBcUQ7QUFDckQsa0RBQTJCO0FBQzNCLG9FQUE0QztBQUU1QyxJQUFNLHlCQUF5QixHQUFHLFVBQUMsS0FBSyxFQUFFLGVBQWU7SUFDckQsSUFBSSxRQUFRLENBQUE7SUFDWixRQUFRLGVBQWUsRUFBRTtRQUNyQixLQUFLLDRCQUFlLENBQUMsT0FBTztZQUN4QixRQUFRLEdBQUcsS0FBSyxDQUFDLE9BQU8sQ0FBQTtZQUN4QixNQUFLO1FBRVQsS0FBSyw0QkFBZSxDQUFDLEtBQUs7WUFDdEIsUUFBUSxHQUFHLEtBQUssQ0FBQyxLQUFLLENBQUE7WUFDdEIsTUFBSztRQUVUO1lBQ0ksUUFBUSxHQUFHLEVBQUUsQ0FBQTtZQUNiLE9BQU8sQ0FBQyxHQUFHLENBQUMsOENBQTRDLGVBQWlCLENBQUMsQ0FBQTtZQUMxRSxNQUFLO0tBQ1o7SUFDRCxPQUFPLFFBQVEsQ0FBQTtBQUNuQixDQUFDLENBQUE7QUFrQkcsOERBQXlCO0FBaEI3QixJQUFNLFNBQVMsR0FBRyxPQUFPLENBQUE7QUFpQnJCLDhCQUFTO0FBZmIsSUFBTSxtQkFBbUIsR0FBRyxVQUFDLEtBQUs7SUFDOUIsT0FBTyxLQUFLLENBQUMsS0FBSyxDQUFDLFNBQVMsQ0FBQyxDQUFBO0FBQ2pDLENBQUMsQ0FBQTtBQWNHLGtEQUFtQjtBQVp2QixJQUFNLGlCQUFpQixHQUFHLGtCQUFrQixDQUFBO0FBRTVDLElBQU0sa0JBQWtCLEdBQUcsVUFBQyxJQUFJO0lBQzVCLE9BQUEseUJBQWMsQ0FBQyxJQUFJLENBQUMsQ0FBQyxFQUFFLENBQUMsaUJBQWlCLENBQUMsQ0FBQyxNQUFNLENBQUMsdUJBQXVCLENBQUM7QUFBMUUsQ0FBMEUsQ0FBQTtBQVUxRSxnREFBa0I7QUFSdEIsSUFBTSx3QkFBd0IsR0FBRyxVQUFDLElBQUksSUFBSyxPQUFBLGdCQUFNLENBQUMsSUFBSSxDQUFDLENBQUMsTUFBTSxDQUFDLFlBQVksQ0FBQyxFQUFqQyxDQUFpQyxDQUFBO0FBU3hFLDREQUF3QjtBQVA1QixJQUFNLGtCQUFrQixHQUFHLFVBQUMsSUFBSSxJQUFLLE9BQUEsZ0JBQU0sQ0FBQyxJQUFJLElBQUksQ0FBQyxJQUFJLENBQUMsQ0FBQyxDQUFDLE1BQU0sQ0FBQyxxQkFBcUIsQ0FBQyxFQUFwRCxDQUFvRCxDQUFBO0FBUXJGLGdEQUFrQiJ9